<template>
    <b-modal :visible="showAdminModal === 'addEditRole'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4 class="modal-title" v-if="item">Изменить роль {{item.name}}</h4>
            <h4 class="modal-title" v-else>Добавить роль</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сохраняем..."></loading>
        <form v-else сlass="form-horizontal">
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.name.$error }">
                <label for="item-name" class="col-4 col-md-2 col-form-label">Название (код)</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="item-name"  v-model.trim="newDataItem.name" @input="$v.newDataItem.name.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.name.$error">Название обязательно должно быть указано латиницей, минимум {{$v.newDataItem.name.$params.minLength.min}} символа</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="item-sort" class="col-4 col-md-2 col-form-label">Описание</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="item-sort"  v-model.trim="newDataItem.description">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-4 col-md-2 col-form-label">Пользователи</label>
                <div class="col-8 col-md-10">
                    <multiselect
                            :options="users"
                            :searchable="true"
                            :multiple="true"
                            :close-on-select="true"
                            :show-labels="false"
                            v-model="selectedUsers"
                            placeholder="Пользователи не заданы"
                            track-by="id" label="fullname"
                            @select="attachUser"
                            @remove="detachUser"
                            @open="loadUsers"
                            :loading="loadingUsers"
                    >
                    </multiselect>
                </div>
            </div>
            <loading v-if="loadingPermissions" :size="3" message="Загружаем права доступа..."></loading>
            <div class="card" v-else>
                <div class="card-header">Права доступа</div>
                <div class="card-block">
                    <div v-for="permission in permissions">
                        <label class="switch switch-lg switch-3d switch-primary mb-2 mr-1">
                            <input type="checkbox"
                                   class="switch-input"
                                   :value="newDataItem.permissions.indexOf(permission.id) !== -1"
                                   :checked="newDataItem.permissions.indexOf(permission.id) !== -1"
                                   @change="changePermission(newDataItem.permissions.indexOf(permission.id), permission.id)">
                            <span class="switch-label"></span>
                            <span class="switch-handle"></span>
                        </label>
                        {{permission.description}}
                    </div>
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading && !loadingPermissions" :class="{ 'disabled': $v.newDataItem.$invalid }" :disabled="$v.newDataItem.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">
                <template v-if="item">Сохранить изменения</template>
                <template v-else>Добавить роль</template>
            </button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength } from 'vuelidate/lib/validators'
  import addRoleMutate from './../../gql/mutations/Acl/AddRole.graphql'
  import updateRoleMutate from './../../gql/mutations/Acl/UpdateRole.graphql'
  import getPermissionsQuery from './../../gql/queries/Acl/getPermissions.graphql'
  import Multiselect from 'vue-multiselect'
  import getUsers from './../../gql/queries/getUsersForMultiselect.graphql'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal,
        item: state => state.adminStore.editRole
      })
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addEditRole' && this.item) {
          this.setNewDataItem()
        }
        if (val === 'addEditRole' && !this.item) {
          this.clearData()
        }
        if (val === 'addEditRole') {
          this.getPermissions()
        }
      }
    },
    data () {
      return {
        loading: false,
        newDataItem: {
          id: null,
          name: '',
          description: '',
          permissions: [],
          users: []
        },
        loadingUsers: false,
        loadingPermissions: false,
        permissions: [],
        selectedUsers: [],
        users: []
      }
    },
    methods: {
      setNewDataItem () {
        const item = this.item
        this.selectedUsers = item.users
        this.newDataItem = Object.assign({}, item)
        this.newDataItem.permissions = []
        item.permissions.forEach((permission) => {
          this.newDataItem.permissions.push(permission.id)
        })
        this.newDataItem.users = []
        item.users.forEach((user) => {
          this.newDataItem.users.push(user.id)
        })
      },
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.item) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addRoleMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Роль успешно добавлена',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      updateItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: updateRoleMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Роль успешно обновлена',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      hideModal () {
        this.$store.commit('SET_ADMIN_EDIT_ROLE', null)
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      clearData () {
        this.newDataItem = {
          id: null,
          name: '',
          description: '',
          permissions: [],
          users: []
        }
        this.selectedUsers = []
        this.$v.newDataItem.$reset()
      },
      getPermissions () {
        this.loadingPermissions = true
        this.$apollo.query({
          query: getPermissionsQuery
        }).then((result) => {
          this.permissions = result.data.permissions
          this.loadingPermissions = false
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loadingPermissions = false
        })
      },
      changePermission (index, id) {
        if (index !== -1) {
          this.newDataItem.permissions.splice(index, 1)
        } else {
          this.newDataItem.permissions.push(id)
        }
      },
      /**
       * Подргрузка менеджеров
       * активируется при открытии селекта
       */
      loadUsers () {
        this.loadingUsers = true
        this.$apollo.query({
          query: getUsers
        }).then(result => {
          this.users = result.data.users
          this.loadingUsers = false
        }).catch(error => {
          console.log(error)
          this.loadingUsers = false
        })
      },
      attachUser (user) {
        this.newDataItem.users.push(user.id)
      },
      detachUser (user) {
        let index = this.newDataItem.users.indexOf(user.id)
        this.newDataItem.users.splice(index, 1)
      }
    },
    components: {
      Multiselect
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddEditRole.vue?74a2955f